import { useContext } from "react";
import { TemplateWrapped } from "../../../../Layout";
import CustomPanel from "../../../../CustomPanel";
import Category from "../Category";
import ShareBookmarksContextProvider from "../context/ShareBookmarksContextProvider";
import ShareBookmarksContext from "../context/ShareBookmarksContext";
import { Button } from "react-bootstrap";
import { getTheme } from "../../../../../constants/getTheme";

const ShareBookmarks = () => {
  const theme = getTheme(process.env.REACT_APP_CLIENT_THEME);
  return (
    <ShareBookmarksContextProvider>
      <ShareBookmarksContent theme={theme} />
    </ShareBookmarksContextProvider>
  );
};

const ShareBookmarksContent = ({ theme }) => {
  const { template, handleSaveSharedBookmarks } = useContext(
    ShareBookmarksContext,
  );

  const { name = "", content = [] } = template;

  return (
    <TemplateWrapped title={name}>
      <CustomPanel>
        <div className="d-flex justify-content-between">
          <h4 className="mb-4">Categories</h4>
          <Button
            className={`${theme.hoverPrimaryClassButton} mt-3`}
            style={{ backgroundColor: theme.primary }}
            onClick={handleSaveSharedBookmarks}
          >
            Share Elements
          </Button>
        </div>
        <Category categories={content} theme={theme} />
      </CustomPanel>
    </TemplateWrapped>
  );
};

export default ShareBookmarks;
